var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoGavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 31.4999H18C18.825 31.4999 19.5 32.1749 19.5 32.9999C19.5 33.8249 18.825 34.4999 18 34.4999H3C2.175 34.4999 1.5 33.8249 1.5 32.9999C1.5 32.1749 2.175 31.4999 3 31.4999ZM7.86 12.1049L12.105 7.85989L31.2 26.9549C32.37 28.1249 32.37 30.0299 31.2 31.1999C30.03 32.3699 28.125 32.3699 26.955 31.1999L7.86 12.1049ZM20.595 3.61489L24.84 7.85989C26.01 9.02989 26.01 10.9349 24.84 12.1049L22.71 14.2349L14.235 5.74489L16.35 3.62989C17.52 2.44489 19.425 2.44489 20.595 3.61489ZM5.745 14.2199L14.235 22.7099L12.12 24.8249C10.95 25.9949 9.045 25.9949 7.875 24.8249L3.63 20.5799C2.46 19.4099 2.46 17.5049 3.63 16.3349L5.745 14.2199Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGavel);
export default __webpack_public_path__ + "static/media/ico-gavel.83c87ce7e3bbbe1a6596e330d9f216dc.svg";
export { ForwardRef as ReactComponent };